import logo from './Lloyds.svg';

const LloydsLogo = () => {
    return <img src={logo} alt="Lloyds bank logo" data-testid="lloyds-logo" />;
};

LloydsLogo.borderColor = '#ffffff';
LloydsLogo.textColor = '#ffffff';
LloydsLogo.backgroundColor = '#006a4d';

// eslint-disable-next-line import/no-default-export
export default LloydsLogo;
